import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
@Component({
    selector: 'kh-limited-text-editor',
    templateUrl: './limited-text-editor.component.html',
    styleUrls: ['./limited-text-editor.component.less'],
    standalone: false
})
export class LimitedTextEditorComponent {
  @Input() public showToolbar: boolean = true;
  @Input() public questionText!: string;
  @Output() public questionTextChange = new EventEmitter<string>();

  public readonly editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: false,
    rawPaste: true,
    height: 'auto',
    minHeight: '25px',
    maxHeight: '32vh',
    minWidth: '100%',
    width: '100%',
    enableToolbar: true,
    showToolbar: true,
    sanitize: false,
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold'],
      ['undo'],
      ['redo'],
      ['insertVideo'],
      ['fontSize'],
      ['fontName'],
      ['customClasses'],
      ['removeFormat'],
      ['subscript'],
      ['superscript'],
      ['insertHorizontalRule'],
      ['textColor'],
      ['backgroundColor'],
      ['indent'],
      ['outdent'],
      ['justifyLeft'],
      ['justifyCenter'],
      ['justifyRight'],
      ['justifyFull'],
      ['insertUnorderedList'],
      ['insertOrderedList'],
      ['unlink'],
      ['link'],
      ['strikeThrough'],
      ['heading'],
    ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  public changeValue(questionText: string): void {
    this.questionTextChange.emit(questionText);
  }
}
